module.exports = __webpack_public_path__ + "img/5.b25b30da.jpg";